<template>
  <div>
    <!-- <div
      v-if="Speaker"
      id="speakerAddEdit"
      class="modal fade crenew-session-popuop add-speaker"
    >
      <div class="modal-dialog add_addendee-popup">
        <div class="modal-content">

          <div class="register_popup">
            <div class="modal-header">
              <h4
                class="modal-title page-head"
                v-if="Speaker && Speaker.AttendeeId == undefined"
              >
                Add new speaker
              </h4>
              <h4 class="modal-title page-head" v-else>Update speaker</h4>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
          </div>


          <div class="modal-body py-0">
            <div class="ss-cns-body-wrap">
              <h5 class="my-4"><strong>Basic Info</strong></h5>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>First Name*</label>
                    <input
                      type="Text"
                      class="form-control ss-cns-name"
                      placeholder="First Name"
                      v-model="Speaker.FirstName"
                    />
                  </div>
                  <div>
                    <label>Last Name</label>
                    <input
                      type="Text"
                      class="form-control ss-cns-name"
                      placeholder="Last Name"
                      v-model="Speaker.LastName"
                    />
                  </div>
                  <div class="form-group">
                    <label>Email*</label>
                    <input
                      type="Text"
                      class="form-control"
                      placeholder="Enter Email"
                      v-model="Speaker.Email"
                    />
                  </div>
                  <div class="form-group">
                    <label>Phone Number</label>
                    <input
                      type="Text"
                      class="form-control"
                      placeholder="Enter Phone Number"
                      v-model="Speaker.Phone"
                    />
                  </div>
                  <hr />
                </div>
                <div class="col-md-6 ss-add-imgbox-wrap text-center">
                  <div class="ss-add-imgbox mx-auto">
                    <img src="../assets/Images/avatar.jpg" alt="e2m" />
                  </div>
                  <p>
                    JPG or PNG no larger than 10MB.<br />Square image looks the
                    best
                  </p>
                  <div class="custom--inputfile-btn-hld">
                    <input type="file" class="custom--inputfile" />
                    <button type="button" class="btn btn-default">
                      Choose File
                    </button>
                  </div>
                </div>
              </div>


              <h5 class="my-4"><strong>Others Info (Optional)</strong></h5>
              <div class="row">
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Organization</label>
                    <input
                      type="Text"
                      v-model="Speaker.Company"
                      class="form-control"
                      placeholder="Organization Name"
                    />
                  </div>
                </div>
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Job Title</label>
                    <input
                      type="Text"
                      v-model="Speaker.Designation"
                      class="form-control"
                      placeholder="Add Job Title"
                    />
                  </div>
                </div>
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Website</label>
                    <input
                      type="Text"
                      v-model="Speaker.Website"
                      class="form-control"
                      placeholder="Organization Name"
                    />
                  </div>
                </div>
                <div class="col-md-6 py-0">
                  <div class="form-group">
                    <label>Country</label>
                    <select v-model="Speaker.Country" class="form-control">
                      <option value="">Select</option>
                      <option
                        v-for="country in CountryList"
                        :key="country"
                        :value="country"
                      >
                        {{ country }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12 py-0">
                  <div class="form-group mb-0">
                    <label>Enter Search Keywords</label>
                    <textarea
                      type="Text"
                      class="form-control"
                      cols="5"
                      placeholder="Add multiple Keywords separated by comma.eg:marketing,branding,techonology"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="col-md-12 py-0">
                  <label>Short Bio</label>
                  <textarea type="Text" class="form-control" placeholder="">
                  </textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer ss-cns-foo-btn">
            <v-btn
              outlined
              color="warning"
              class="px-8"
              data-dismiss="modal"
              width="120px"
            >
              Cancel
            </v-btn>
            <v-btn
              :loading="IsSubmitting"
              dark
              class="px-8"
              color="#1973e7"
              @click="SaveSpeaker"
              width="120px"
            >
              Save
            </v-btn>
          </div>
        </div>
      </div>
    </div> -->

    <v-dialog v-if="Speaker" v-model="Speaker" max-width="1024" scrollable>
      <v-card class="attendee-add-wrap-mod">
        <div style="position: absolute; right: 10px; top: 15px">
          <v-icon
            style="z-index: 2"
            size="32"
            @click="
              cropImageUrl = null;
              Speaker = null;
            "
            >close</v-icon
          >
        </div>
        <v-card-title
          v-if="Speaker && Speaker.AttendeeId == undefined"
         
        >
          <h5>Add new speaker</h5>
        </v-card-title>
        <v-card-title v-else class="text-h5"> Update speaker </v-card-title>

        <v-card-text>
          <div class="ss-cns-body-wrap" v-if="cropImageUrl == null">
            <h5 class="my-4"><strong>Basic Info</strong></h5>
            <!--top area start-->
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>First Name*</label>
                  <input
                    type="Text"
                    class="form-control ss-cns-name"
                    placeholder="First Name"
                    v-model="Speaker.FirstName"
                    id="firstNameSpeaker"
                  />
                </div>
                <div class="form-group">
                  <label>Last Name</label>
                  <input
                    type="Text"
                    class="form-control ss-cns-name"
                    placeholder="Last Name"
                    v-model="Speaker.LastName"
                  />
                </div>
                <div class="form-group">
                  <label>Email*</label>
                  <input
                    type="Text"
                    class="form-control"
                    placeholder="Enter Email"
                    v-model="Speaker.Email"
                  />
                </div>
                <div class="form-group">
                  <label>Phone Number</label>
                  <input
                    type="Text"
                    class="form-control"
                    placeholder="Enter Phone Number"
                    v-model="Speaker.Phone"
                  />
                </div>
                <hr />
              </div>
              <div class="col-md-6 ss-add-imgbox-wrap text-center">
                <div class="ss-add-imgbox mx-auto">
                  <img
                    v-if="Speaker.ProfilePictureURL"
                    :src="Speaker.ProfilePictureURL"
                    alt="e2m"
                  />
                  <img v-else src="../assets/Images/reg-ico/default-profile-pic.svg" alt="e2m" />
                </div>
                <p>
                  JPG or PNG 200x200 px or 1:1 ratio<br/>no larger than 10MB.<br />Square image looks the
                  best
                </p>
                <div class="custom--inputfile-btn-hld">
                  <input
                    type="file"
                    class="custom--inputfile"
                    @change="update_avatar"
                    accept="image/*"
                  />
                  <button type="button" class="btn btn-default">
                    Choose File
                  </button>
                </div>
              </div>
            </div>
            <!--top area end-->

            <h5 class="my-4"><strong>Others Info (Optional)</strong></h5>
            <div class="row">
              <div class="col-md-6 pb-0">
                <div class="form-group">
                  <label>Organization</label>
                  <input
                    type="Text"
                    v-model="Speaker.Company"
                    class="form-control"
                    placeholder="Organization Name"
                  />
                </div>
              </div>
              <div class="col-md-6 pb-0">
                <div class="form-group">
                  <label>Job Title</label>
                  <input
                    type="Text"
                    v-model="Speaker.Designation"
                    class="form-control"
                    placeholder="Add Job Title"
                  />
                </div>
              </div>
              <div class="col-md-6 py-0">
                <div class="form-group">
                  <label>Website</label>
                  <input
                    type="Text"
                    v-model="Speaker.Website"
                    class="form-control"
                    placeholder="Website"
                  />
                </div>
              </div>
              <div class="col-md-6 py-0 d-none">
                <div class="form-group">
                  <label>Country</label>
                  <select v-model="Speaker.Country" class="form-control">
                    <option value="">Select</option>
                    <option
                      v-for="country in CountryList"
                      :key="country"
                      :value="country"
                    >
                      {{ country }}
                    </option>
                    <!-- <option>A</option>
                      <option>b</option> -->
                  </select>
                </div>
              </div>
              <div class="col-md-12 py-0">
                <div class="form-group mb-0">
                  <label>Enter Search Keywords</label>
                  <!-- <textarea
                    type="Text"
                    class="form-control"
                    cols="5"
                    placeholder="Add multiple Keywords separated by comma.eg:marketing,branding,techonology"
                  >
                  </textarea> -->

                       <input-tag
                    tabindex="9"
                    id="txtTags"
                    class="w-full mt-4 form-control"
                    placeholder="Add multiple keywords separated by comma. eg: marketing, branding, technology"
                    v-model="Speaker.Tags"
                    name="Tags"
                  ></input-tag>
                </div>
              </div>
              <div class="col-md-12 py-0">
                <div class="form-group">
                  <label>Short Bio</label>
                  <textarea type="Text" class="form-control" placeholder="" v-model="Speaker.Profile">
                  </textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="ss-cns-body-wrap" v-else>
            <h5 class="my-4">
              <strong
                ><v-icon
                  @click="cropImageUrl = null"
                  size="30"
                  color="black"
                  class="mr-2 cursor-pointer"
                  >mdi-arrow-left</v-icon
                >Aspect Ratio for this image is {{ displayImageRatio }}. To crop
                this image, simply drag and click Upload</strong
              >
            </h5>

            <cropper
              :key="resetCropper"
              v-bind:aspectValue="imageRatio"
              :sourceImage="cropImageUrl"
              :file="imageFileDetails"
              :uploadPath="folderImageUploadPath"
              :clientId="clientId"
              :eventId="eventId"
              @uploadedImagePath="uploadedImagePath"
            />
          </div>
        </v-card-text>

        <v-divider class="m-0" v-if="cropImageUrl == null"></v-divider>
        <v-card-actions v-if="cropImageUrl == null">
          <div class="full-width text-right py-2 final-button">
            <v-btn
              color="#1c1d26"
              large
              class="mr-2 cancel-standard"
              outlined
              width="100px"
              @click="
                cropImageUrl = null;
                Speaker = null;
              "
            >
              Cancel
            </v-btn>

            <v-btn
              :loading="IsSubmitting"
              color="#2376e5"
              dark
              large
              class="save-standard"
              @click="SaveSpeaker"
              width="100px"
            >
              Save
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- :active.sync="popupCropper" -->
    <!-- <div
      id=""
      class="holamundo registrationType-popup"
      title="Crop Image"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photo-resize
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </div> -->
  </div>
</template>

<script>

//import firebase from "firebase";
//const storageRef = firebase.storage().ref();
//import PhotoResize from "../components/PhotoResize.vue";
import Cropper from "../components/CropperComponent.vue";
import InputTag from "vue-input-tag";
import axios from "axios";
import APIs from "@/components/APIInit";
import common from "@/common";
import { bus } from "@/main";

let vm;
export default {
  name: "speaker",
  components: {
    Cropper,
    InputTag
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    clientId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
    event_collectionName: {
      type: String,
      default: "",
    },
    Speaker: {
      type: Object,
      default: () => ({
        FormType: "FREE",
        RegistrationType: {
          ColorCode: "",
          RegistrationType: "Attendee",
          RegistrationTypeId: "",
        },
        Name: "",
        Company: "",
        CreateDate: "",
        Designation: "",
        Email: "",
        Tags: "",
        IsAttendee: true,
        FirstName: "",
        Group: "",
        LastModifiedDate: "",
        LastName: "",
        Phone: "",
        Profile: "",
        ProfilePictureURL: "",
        SpeakerId: "",
        Website: "",
        IsPublished: true,
        Resources: [],
        SocialLinks: [
          { Facebook: "" },
          { Twitter: "" },
          { GooglePlus: "" },
          { LinkedIn: "" },
        ],
      }),
    },
  },
  data() {
    return {
      imageRatio: 1 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "1:1",
      popupCropper: false,
      IsSubmitting: false,
      CountryList: [],
      uploadedFile: null,
      imageFileDetails: null,
      folderImageUploadPath: null,
    };
  },
  watch: {},
  mounted() {
    vm = this;
    vm.CountryList = common.getCountryList();
       setTimeout(() => {
        document.getElementById("firstNameSpeaker").focus();
      }, 500);
  },
  beforeDestroy() {},
  methods: {
    uploadedImagePath(data) {
      if (data && data.Status == 200) {
        vm.cropImageUrl = null;
        vm.imageFileDetails = null;
        vm.folderImageUploadPath = null;
        vm.Speaker.ProfilePictureURL = data.Path;
      } else {
        alert("fail");
      }
    },
    SaveSpeaker() {
      console.log("speaker====",vm.Speaker);

      // if(!vm.Speaker.AttendeeId){
      //   vm.Speaker.IsPublished = true;
      //   vm.Speaker.IsAttendee = true;
      // }

      if (!vm.Speaker.FirstName) {
        vm.Speaker.FirstName = "";
      }
      if (!vm.Speaker.LastName) {
        vm.Speaker.LastName = "";
      }
      if (!vm.Speaker.Email) {
        vm.Speaker.Email = "";
      }

      if (!vm.Speaker.FirstName) {
        vm.showSnackbar("First Name is mandatory", "error", "top");
        return;
      }
      if (!vm.Speaker.Email) {
        vm.showSnackbar("Email is mandatory", "error", "top");
        return;
      }
      if (!vm.isValidEmail(vm.Speaker.Email)) {
        vm.showSnackbar("Email is not valid", "error", "top");
        return;
      }
      
      vm.IsSubmitting = true;
      //storageRef.child(vm.event_collectionName + '/Speaker/profileImage/' + (new Date().getTime()) + "_" + file.name).putString(Attendee.ProfilePictureURL, 'data_url').then(function (snapshot) {
      // snapshot.ref.getDownloadURL().then(function (url) {
      //   profileUrl = url.toString();
      //alert(vm.Speaker.IsPublished);

      let speaker = {
        UserId: vm.Speaker.AttendeeId,
        Name: vm.Speaker.FirstName.trim() + " " + vm.Speaker.LastName.trim(),
        Company: vm.Speaker.Company,
        CreatedDate: new Date(),
        Designation: vm.Speaker.Designation,
        Email: vm.Speaker.Email.toLowerCase().trim(),
        IsAttendee: vm.Speaker.IsAttendee == true ? true : false,
        IsSpeaker: vm.Speaker.IsAttendee == true ? true : false, //** need to store in attendee doc
        FirstName: vm.Speaker.FirstName.trim(),
        Group: vm.Speaker.Group,
        LastModifiedDate: new Date(),
        LastName: vm.Speaker.LastName.trim(),
        Phone: vm.Speaker.Phone,
        Profile: vm.Speaker.Profile,
        IsPublished: vm.Speaker.IsPublished == true ? true : false,
        ProfilePictureURL: vm.Speaker.ProfilePictureURL
          ? vm.Speaker.ProfilePictureURL
          : "",

        //SpeakerId: null,
        Website: vm.Speaker.Website,
        Resources: [],
        UserRoles: [
          {
            RoleID: 10,
            RoleName: "AppUser",
          },
          {
            RoleID: 11,
            RoleName: "Speaker",
          },
        ],
        SocialLinks: [
          { Facebook: "" },
          { GooglePlus: "" },
          { LinkedIn: "" },
          { Twitter: "" },
        ],
        Tags: vm.Speaker.Tags ? vm.Speaker.Tags : "",
      };
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: speaker,
        sendMail: 0,
      };
      axios
        .post(APIs.AddSpeaker, requestData, { headers: headers })
        .then(function (res) {
          vm.IsSubmitting = false;
          debugger;
          if (res.status == 200) {
            // resolve({
            //   status: 200,
            //   message: "Data Added.",
            //   Id: res.data.data.UserId,
            // });
            if (vm.Speaker.AttendeeId == undefined) {
              vm.$emit("OnAddSpeakerSuccess");
            } else {
              vm.$emit("OnUpdateSpeakerSuccess");
            }
          } else {
            vm.showSnackbar("Something went wrong", "error", "top");
            //resolve({ status: 500, message: "Data Not Added." });
          }
        })
        .catch(function (error) {
          vm.IsSubmitting = false;
          //vm.$emit("OnAddSpeakerSuccess");
          vm.showSnackbar("Something went wrong", "error", "top");
          console.log("Error adding attendee:", error);
          //reject(error);
        });
      //     }).catch(function (error) {
      //         //console.log('download url '+error)
      //     })
      // }).catch(function (error) {
      //     //console.log('imgae upload '+error)
      // })
    },
    croppedImagePath(blob) {
      console.log(blob);
      //this.imgSrc = blob;
      // this.popupCropper = false;
      // if (this.uploadedFile)
      //   vm.uploadImage(blob, `${cn}/Session/LogoImage/`, this.uploadedFile);
    },
    update_avatar(input) {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      bus.$emit("toggleLoader", true);
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        var metadata = {
          contentType: file.type,
        };

           const fileSize = file.size / 1024 / 1024;
          if (fileSize > 10) {
            bus.$emit("toggleLoader", false);
            alert("File size exceeds 10 MB");
            return;
          }

        console.log(metadata);
        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        // let dimension = fileWH.split("x");

        // console.log(dimension);
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            vm.resetCropper += 1;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.imageFileDetails = file;
            vm.folderImageUploadPath =
              obj.eventcollectionname + "/Speaker/profileImage/";
            bus.$emit("toggleLoader", false);
          };
          reader.readAsDataURL(input.target.files[0]);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file) {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.session_data.SessionLogo = res.data[0].value.url;
            this.imgSrc = res.data[0].value.url;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$vs.loading.close();
          // this.$vs.notify({
          //   color: "warning",
          //   position: "top-center",
          //   //title: "Session",
          //   text: "Something went wrong!",
          // });
        });
    },
  },
};
</script>
